import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const UserIcon = props => {
  return (
    <Svg
      width={16}
      height={18}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 5a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0zM8 2.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM4 12.25a2.25 2.25 0 00-2.25 2.25v1.188c0 .018.013.034.031.037 4.119.672 8.32.672 12.438 0a.037.037 0 00.031-.037V14.5A2.25 2.25 0 0012 12.25h-.34a.253.253 0 00-.079.012l-.865.283a8.751 8.751 0 01-5.432 0l-.866-.283a.252.252 0 00-.077-.012H4zM.25 14.5A3.75 3.75 0 014 10.75h.34c.185 0 .369.03.544.086l.866.283a7.251 7.251 0 004.5 0l.866-.283c.175-.057.359-.086.543-.086H12a3.75 3.75 0 013.75 3.75v1.188c0 .754-.546 1.396-1.29 1.517a40.095 40.095 0 01-12.92 0 1.537 1.537 0 01-1.29-1.517V14.5z"
        fill="#001533"
      />
    </Svg>
  );
};

export default UserIcon;
